import {
  BrandApiContentBrandsListingListRequest,
  BrandApiFactory,
  DashboardApiContentSponsoredRetrieveRequest,
  DashboardApiFactory,
  ProductApiFactory,
  ProductApiProductsRecommendedListRequest,
} from '@/clients/unifiedApi';

import { createSession } from '../session';
import { getUnifiedApi } from './unifiedApi';

/**
 * Returns content for the Shop Brands
 */
export const fetchBrandContent = async (payload: BrandApiContentBrandsListingListRequest) => {
  const api = await getUnifiedApi(BrandApiFactory);

  const response = await api.contentBrandsListingList(payload);

  return response.data;
};

export const getSponsoredDashboardContent = async (payload: DashboardApiContentSponsoredRetrieveRequest) => {
  const api = await getUnifiedApi(DashboardApiFactory);

  const response = await api.contentSponsoredRetrieve(payload);

  return response.data;
};

/**
 * Reports sponsored content click to the underlying provider.  This happens
 * in the background and is non-blocking.
 */
export const reportSponsoredContentClickToProvider = async (clickReportingUrl: string) => {
  const session = createSession('');

  return await session.get(clickReportingUrl);
};

/**
 * Even with the payload explicitly related to the Brand, productsRecommendedList won't be brand specific to start.
 *
 * Returns a list of recommended products
 */
export const getProductsRecommendedList = async (payload: ProductApiProductsRecommendedListRequest) => {
  const api = await getUnifiedApi(ProductApiFactory);

  const response = await api.productsRecommendedList(payload);

  return response.data;
};
